<template>
  <v-form ref="recoverForm" @submit.prevent="recover">
    <v-card class="elevation-12">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>User Password Recovery</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-text-field label="New Password"
                      v-model="newPassword"
                      type="password"
                      validate-on-blur
                      :rules="rules.newPassword" />
        <v-text-field label="Confirm Password"
                      v-model="confirmPassword"
                      type="password"
                      validate-on-blur
                      :rules="rules.confirmPassword" />
      </v-card-text>
      <v-card-actions class="px-4">
        <v-btn type="submit" color="primary" large ripple>Change Password</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'RecoverForm',
  props: ['id', 'code'],
  data() {
    return {
      rules: {
        newPassword: [
          (v) => rules.required(v, 'Please enter your new password'),
          (v) => rules.password(v),
        ],
        confirmPassword: [
          (v) => rules.required(v, 'Please confirm your new password'),
          (v) => rules.match(v, this.newPassword, 'Passwords must match'),
        ],
      },
      newPassword: '',
      confirmPassword: '',
    };
  },
  methods: {
    async recover() {
      if (this.$refs.recoverForm.validate()) {
        try {
          await this.$store.dispatch('post', {
            api: 'User/IForgot',
            data: {
              Id: this.id,
              Token: this.code,
              NewPassword: this.newPassword,
              ConfirmPassword: this.confirmPassword,
            },
          });
          this.$emit('snackbar', 'Your password has been reset. Redirecting you to the login panel...');
          setTimeout(() => this.$router.push({ name: 'login' }), 2000);
        } catch (e) {
          // Do nothing
        }
      }
    },
  },
};
</script>
